import { Component, OnInit } from '@angular/core';
import {
  faSitemap,
  faScaleBalanced,
  faMagnifyingGlassChart,
  faComments,
  faTruckFast,
  faRobot,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-section-benefits',
  templateUrl: './section-benefits.component.html',
  styleUrls: ['./section-benefits.component.scss'],
})
export class SectionBenefitsComponent implements OnInit {
  faSitemap = faSitemap;
  faScaleBalanced = faScaleBalanced;
  faMagnifyingGlassChart = faMagnifyingGlassChart;
  faComments = faComments;
  faTruckFast = faTruckFast;
  faRobot = faRobot;

  constructor() {}

  ngOnInit(): void {}
}
